import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 7C14.5523 7 15 7.44772 15 8V14C15 14.5523 14.5523 15 14 15H6C5.44772 15 5 14.5523 5 14V8C5 7.44772 5.44772 7 6 7H14ZM10 9C9.44772 9 9 9.44772 9 10C9 10.3698 9.20157 10.6912 9.5 10.8643V13H10.5V10.8643C10.7984 10.6912 11 10.3698 11 10C11 9.44772 10.5523 9 10 9Z"
      fill="#181818"
    />
    <path
      d="M10 2C11.4643 2 12.6826 2.97429 12.9463 4.2627L11.4893 4.62695C11.4043 3.93252 10.7706 3.39258 10 3.39258C9.17157 3.39258 8.5 4.01688 8.5 4.78613V12.2139C8.5 12.9831 9.17157 13.6074 10 13.6074C10.8284 13.6074 11.5 12.9831 11.5 12.2139V9H13V12.2139L12.9961 12.3574C12.9158 13.8293 11.6051 15 10 15C8.39489 15 7.08421 13.8293 7.00391 12.3574L7 12.2139V4.78613C7 3.24763 8.34315 2 10 2Z"
      fill="#181818"
    />
  </svg>
);
export default SVGComponent;
